// 손풀이 영상 URL 추출/정규화. 백엔드 SolutionVideo.kt 와 정규식 일치.
// youtu.be/{id}, youtube.com/watch?v={id}, /embed/{id}, /shorts/{id} 지원.
// {video=...} 태그 안/밖 모두 인식(해설 텍스트에 임베드된 형태).
const YT_ID = /(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/))([A-Za-z0-9_-]{11})/

/** 문자열에서 YouTube video id 추출. 없으면 null. */
export function extractYouTubeId(text: string | null | undefined): string | null {
  if (!text) return null
  const m = text.match(YT_ID)
  return m ? m[1] : null
}

/** video id → 표준 embed URL. */
export function toYouTubeEmbedUrl(id: string): string {
  return `https://www.youtube.com/embed/${id}`
}

/** 해설 텍스트에서 손풀이 영상 embed URL 추출(정규화). 없으면 null(엣지7 누락 판정). */
export function extractSolutionVideoUrl(text: string | null | undefined): string | null {
  const id = extractYouTubeId(text)
  return id ? toYouTubeEmbedUrl(id) : null
}

function asSafeHttpUrl(candidate: string): string | null {
  try {
    const url = new URL(candidate)
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null

    const hostname = url.hostname.toLowerCase().replace(/^www\./, '')
    if (hostname === 'youtu.be' || hostname === 'youtube.com' || hostname.endsWith('.youtube.com')) {
      return null
    }

    return url.toString()
  } catch {
    return null
  }
}

/**
 * 코칭 미리보기용 영상 URL 추출.
 * 기존 YouTube URL은 embed URL로 정규화하고, 해설 전체가 일반 HTTP(S) URL이거나
 * `{video=URL}` 형식이면 원본 URL을 반환한다. 일반 해설 안의 임의 링크는 영상으로
 * 오인하지 않는다.
 */
export function extractPlayableSolutionVideoUrl(text: string | null | undefined): string | null {
  const youtubeUrl = extractSolutionVideoUrl(text)
  if (youtubeUrl) return youtubeUrl
  if (!text) return null

  const trimmed = text.trim()
  const taggedUrl = trimmed.match(/^\{video=(https?:\/\/[^}\s]+)\}$/i)?.[1]
  return asSafeHttpUrl(taggedUrl ?? trimmed)
}
